// extracted by mini-css-extract-plugin
module.exports = {"root":"IconEdit_root__3IG-g","pencil":"IconEdit_pencil__Nf4Q5"};